"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _TextBox = require("./TextBox");
Object.keys(_TextBox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _TextBox[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _TextBox[key];
        }
    });
});
